var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5339 7.76C21.6227 6.71937 21.1205 5.3832 21.1206 4H17.0006V20.5333C16.9695 21.4283 16.592 22.2761 15.9477 22.898C15.3034 23.5199 14.4427 23.8672 13.5473 23.8667C11.6539 23.8667 10.0806 22.32 10.0806 20.4C10.0806 18.1067 12.2939 16.3867 14.5739 17.0933V12.88C9.97393 12.2667 5.94727 15.84 5.94727 20.4C5.94727 24.84 9.62727 28 13.5339 28C17.7206 28 21.1206 24.6 21.1206 20.4V12.0133C22.7913 13.2131 24.7971 13.8569 26.8539 13.8533V9.73333C26.8539 9.73333 24.3473 9.85333 22.5339 7.76Z",
    fill: "currentColor"
  })));
};
export default SvgTiktok;